import React from 'react';
import { Grid } from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import PageHeader from '../../../components/page-header';
import { GridPanel, dataGridDefaults } from '../../../components/list-grid-panel';
import { useQuestionAnswerCategoryController } from './context/question-answer-category-controller';
import { useQuestionAnswerCategoryState } from './context/question-answer-category-context';
import { DeleteAction, EditAction } from '../../../components/row-actions';
import { QuestionAnswerCategoryDrawer } from './components/question-answer-category-drawer';

export function QuestionAnswerCategoryComponent() {
    const ctrl = useQuestionAnswerCategoryController();
    const { categories, loading, drawer } = useQuestionAnswerCategoryState();

    const columns: GridColDef[] = [
        { field: 'id', headerName: 'ID', width: 80 },
        { field: 'description', headerName: 'Descrição', flex: 1, minWidth: 240 },
        { field: 'questionCount', headerName: 'Perguntas', width: 120, type: 'number' },
        {
            field: 'actions', headerName: 'Ações', width: 100, sortable: false,
            renderCell: (params) => {
                const inUse = params.row.questionCount > 0;
                return (
                    <React.Fragment>
                        <EditAction onClick={() => ctrl.openDrawer(params.row)} />
                        <DeleteAction title={inUse ? 'Categoria com perguntas vinculadas' : 'Excluir'} disabled={inUse} onClick={() => ctrl.handleDelete(params.row)} />
                    </React.Fragment>
                );
            }
        }
    ];

    return (
        <React.Fragment>
            <Grid item xs={12}>
                <PageHeader
                    title="Categorias de Perguntas"
                    subtitle="Organize as perguntas frequentes do portal por assunto"
                    breadcrumbs={[{ label: 'Categorias de Perguntas' }]}
                />
            </Grid>
            <Grid item xs={12}>
                <GridPanel addLabel="Nova Categoria" onAdd={() => ctrl.openDrawer()}>
                    <DataGrid
                        {...dataGridDefaults}
                        rows={categories}
                        columns={columns}
                        loading={loading}
                        initialState={{ pagination: { paginationModel: { pageSize: 25 } } }}
                    />
                </GridPanel>
            </Grid>

            <QuestionAnswerCategoryDrawer
                open={drawer.open}
                initial={drawer.category}
                isSaving={ctrl.isSaving}
                onClose={ctrl.closeDrawer}
                onSave={ctrl.handleSave}
            />
        </React.Fragment>
    );
}
